<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="cancel"
    :modal="false"
    width="900px"
    :title="$t('langcfg.txtWifiConfig')"
    style="background: rgba(0, 0, 0, 0.4); z-index: 1999"
    class="dialog"
  >
    <el-row justify="space-between" style="font-size: 35px; margin-top: 10px; width: 820px">
      <el-col style="text-align: left; line-height: 50px" :span="12">
        <span>SSID:</span>
      </el-col>
      <el-col style="text-align: left; line-height: 50px" :span="12">
        <span>{{ wifiItem.ssid }}</span>
      </el-col>
    </el-row>
    <network-info
      :wifiCfg="wifiCfg"
      @disconnect="disconnect"
      @cancel="cancel"
      @reconnect="reconnect"
    ></network-info>
  </el-dialog>
</template>

<script>
import NetworkInfo from "./NetworkInfo";

export default {
  data() {
    return {
      autoUpload: false,
      inputDisabled: false,
      dhcp: "auto",
      inputItems: [
        {
          title: "IP",
          field: "address",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["address"] || "",
          placeholder: ""
        },
        {
          title: this.$t("langcfg.txtGateWay"),
          field: "gateway",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["gateway"] || "",
          placeholder: ""
        },
        {
          title: this.$t("langcfg.txtMask"),
          field: "mask",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["mask"] || "",
          placeholder: ""
        },
        {
          title: "DNS",
          field: "dns",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["dns"] || "",
          placeholder: ""
        }
      ]
    };
  },
  components: {
    NetworkInfo
  },
  props: {
    wifiItem: Object,
    wifiCfg: Object,
    show: Boolean
  },
  mounted: function () {
    this.dhcp = this.wifiCfg["method"] === "DHCP" ? "auto" : "";
  },
  methods: {
    save() {
      this.$emit("close");
      this.showDialog = false;
    },
    cancel() {
      this.$emit("close");
      this.showDialog = false;
    },
    commitConfig: function () {
      let config = {};
      let err = false;
      this.inputItems[0].val = this.dhcp;
      config.mode = this.dhcp === "dhcp" ? 0 : 1;
      if (this.dhcp === "dhcp") {
        this.$emit("config", config);
        return;
      }
      for (let id in this.inputItems) {
        config[this.inputItems[id]["field"]] = this.inputItems[id]["val"];
      }
      for (let id in this.inputItems) {
        if (
          this.inputItems[id]["type"] !== "select" &&
          !this.checkIpv4Config(this.inputItems[id]["val"])
        ) {
          this.inputItems[id]["class"] = "red";
          err = true;
          break;
        }
      }
      if (!err) {
        this.$emit("config", config);
      } else {
        this.$emit("close");
        this.showDialog = false;
      }
    },
    disconnect: function (wifiInfo) {
      this.$emit("disconnect", wifiInfo);
    },
    reconnect: function (wifiInfo) {
      wifiInfo.ssid = this.wifiItem.ssid;
      wifiInfo.flag = this.wifiItem.flag;
      this.$emit("reconnect", wifiInfo);
      this.showDialog = false;
    },
    initInputClass: function () {
      for (let id in this.inputItems) {
        this.inputItems[id]["class"] = "normal";
      }
    }
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    },
    initInputDisabled: function () {
      return this.dhcp === "auto";
    }
  }
};
</script>
<style lang="less" scoped>
.normal {
  color: black;
  width: 100%;
  border: none;
}
.red {
  color: black;
  width: 100%;
  border: 2px red solid;
}
.loginSelect {
  color: black;
  font-size: 25px;
  float: left;
  color: black;
  width: 180px;
  height: 52px;
}
.cb_AutoUpload {
  width: 35px;
  height: 35px;
}
.btn-loginOK {
  width: 100px;
  height: 50px;
  font-size: 20px;
}
.btn-logincancel {
  width: 100px;
  height: 50px;
  margin-left: 150px;
  font-size: 20px;
}
.buttonArea {
  position: fixed;
  top: 380px;
  left: 10px;
  width: 800px;
  text-align: center;
}
input:disabled {
  color: gray;
  border-left: 1px solid gray;
}
.el-button {
  margin-left: 5%;
  font-size: @header-fs;
  padding: 12px 15px;
  border: 1px solid gray;
}
.el-button:hover {
  opacity: 0.7;
}
.ssid {
  padding-left: 15px;
  font-size: 35px;
  color: white;
  padding-top: 5px;
  margin-bottom: 20px;
}
// .dialog /deep/ .el-input__inner {
//   background-color: #2d3039;
//   color: #ffffff;
//   // border: none;
// }
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/WifiConfig.vue